import React from "react";
import { motion } from "framer-motion";
import { useLang, UI } from "../i18n";
import { BOUTIQUE, THEMES } from "../content";
import { useLenis, Reveal } from "../components/motion";
import { PageHero } from "../components/PageHero";
import { MiniSite, Barcode } from "../components/motifs";
import { ContactSection } from "../components/Layout";

export default function Boutique() {
  useLenis();
  const { t } = useLang();
  const th = THEMES.boutique;
  return (
    <MiniSite theme={th}>
      <PageHero
        code="DUTY FREE · AST"
        overline={t(UI.nav.boutique)}
        title={t(BOUTIQUE.title)}
        subtitle={t(BOUTIQUE.intro)}
        image={BOUTIQUE.products[2].img}
      />
      <section className="pb-24 md:pb-32 max-w-[1400px] mx-auto px-5 md:px-10">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {BOUTIQUE.products.map((p, i) => (
            <Reveal key={i} delay={i * 0.06}>
              <motion.article data-testid={`product-${i}`} whileHover={{ y: -6 }}
                className="group overflow-hidden rounded-lg border border-white/10"
                style={{ backgroundColor: "var(--ms-surface)" }}>
                <div className="relative aspect-square overflow-hidden bg-black/40">
                  <img src={p.img} alt={t(p.name)} className="w-full h-full object-cover opacity-90 group-hover:opacity-100 group-hover:scale-105 transition-all duration-500" />
                  <span className="absolute top-4 left-4 font-mono text-[9px] uppercase tracking-[0.25em] bg-black/70 backdrop-blur px-3 py-1.5 rounded-full">{p.tag}</span>
                  <div className="absolute bottom-4 right-4 rotate-[5deg] text-black font-mono text-sm font-bold px-3.5 py-1.5 rounded-sm shadow-lg"
                    style={{ backgroundColor: th.accent }}>
                    {p.price}
                  </div>
                </div>
                <div className="p-6 flex items-center justify-between gap-4">
                  <div>
                    <h3 className="font-heading text-lg font-semibold">{t(p.name)}</h3>
                    <Barcode className="h-4 w-24 text-white/30 mt-2" />
                  </div>
                  <a href="#contact" data-testid={`product-order-${i}`}
                    className="font-heading text-xs uppercase tracking-wide border border-white/20 rounded-full px-4 py-2 hover:border-transparent hover:text-black transition-colors duration-300"
                    style={{ "--tw-hover-bg": th.accent }}
                    onMouseEnter={(e) => { e.currentTarget.style.backgroundColor = th.accent; }}
                    onMouseLeave={(e) => { e.currentTarget.style.backgroundColor = "transparent"; }}>
                    {t({ fr: "Commander", en: "Order", es: "Pedir" })}
                  </a>
                </div>
              </motion.article>
            </Reveal>
          ))}
        </div>
      </section>
      <ContactSection defaultProgram={t({ fr: "Boutique", en: "Shop", es: "Tienda" })} accent={th.accent} />
    </MiniSite>
  );
}
